import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route} from 'react-router';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';
import './App/css/App.css';
import { HashRouter } from 'react-router-dom';

ReactDOM.render((
<HashRouter>
    <Route path="/" component={App} />
    {/*<Route path="/about/" component={About} />*/}
  </HashRouter>
  ), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
